import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Box } from 'reflexbox';

import { Select, SelectProps } from '@treams/treams-ui';
import { IdentityProvider, useIdentityProvidersQuery } from 'generated/graphql';
import { SubSectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import { ParagraphSmall } from 'packages/kakapo-ui-kit/components/common/Paragraph';

type Props = {
	onChange: (identityProvider: IdentityProvider['id']) => void;
};

const BulkSSOIdentityProvider = ({ onChange }: Props) => {
	const { t } = useTranslation();

	const { data } = useIdentityProvidersQuery();
	const [selected, setSelected] = useState<SelectProps['selectedValue']>();

	const options: SelectProps['options'] = data?.identityProviders.map(({ id }) => {
		return { value: id, title: id };
	});

	const handleChange = (provider: SelectProps['selectedValue']) => {
		if (provider) {
			setSelected(provider);
			onChange(provider);
		}
	};

	return (
		<Flex mb={3} flexDirection="row">
			<Box flexGrow={1}>
				<Box mb={2}>
					<SubSectionTitle>Identity Provider</SubSectionTitle>
				</Box>
				<ParagraphSmall color="slateBlue">
					{t('employees.bulkSSO.identityProvider.description')}
				</ParagraphSmall>
			</Box>
			<Box mt={3} flexShrink={0} flexGrow={0}>
				<Select
					placeholder={t('employees.bulkSSO.identityProvider.placeholder')}
					selectedValue={selected}
					options={options}
					onChange={(option) => handleChange(option)}
				/>
			</Box>
		</Flex>
	);
};

export default BulkSSOIdentityProvider;
